import { DEVICES_TABLE as devicesTable } from './devicesTable';

export const VIEW_USER = {
  devicesTable
};
